import { useState } from "react";
import ListItem from "../TaskCreatorAndEditorSheet/ListItem/ListItem";
import ErrorAddOn from "../TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";
import { useTranslation } from "@coworker/locales";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithPTagsOrdered } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { ConfirmSheetModal } from "@coworker/apprestructured/src/shared/components/ConfirmSheetModal/ConfirmSheetModal";
import { isLoading, Loading } from "../../loading";
import { LOADING } from "../../loading";
import { useItemsWithPieces } from "../../services/useItemsWithPieces";
import { ArticlesPrintPtagsQuantityContent } from "./ArticlesPrintPtagsQuantityContent/ArticlesPrintPtagsQuantityContent";

interface ArticlesPrintPtagsQuantityProps {
  disabled?: boolean;
  isError?: boolean;
  itemNosAndTypeWithOrderedDetails:
    | ItemNoAndTypeWithPTagsOrdered[]
    | null
    | Loading;
  items: Item[];
  onPrintPtagsQuantityChange: (
    itemNo: string,
    newPrintPtagsQuantity: number
  ) => void;
  handleConfirm: () => void;
}
export const ArticlesPrintPtagsQuantity = ({
  disabled,
  isError,
  itemNosAndTypeWithOrderedDetails,
  items,
  onPrintPtagsQuantityChange,
  handleConfirm,
}: ArticlesPrintPtagsQuantityProps) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { t } = useTranslation();
  const itemsWithPieces = useItemsWithPieces(
    items,
    itemNosAndTypeWithOrderedDetails ?? LOADING
  );

  if (isLoading(itemsWithPieces)) {
    return <div>Loading...</div>;
  }

  const handleConfirmWithClose = () => {
    handleConfirm();
    handleCloseModal();
  };

  const totalPTags = Array.isArray(itemNosAndTypeWithOrderedDetails)
    ? itemNosAndTypeWithOrderedDetails.reduce(
        (acc, item) => acc + item.ptags_ordered,
        0
      )
    : 0;
  const description = `${totalPTags} p-tags`;
  const emphasised = true;
  return (
    <>
      <ListItem
        testId="print-ptags-list-item"
        title={t("howManyPTagsString")}
        onClick={handleOpenModal}
        emphasised={emphasised}
        description={description}
        disabled={disabled}
        addOn={
          isError ? (
            <ErrorAddOn testId="print-ptags-error">
              {t("pleaseFillInString")}
            </ErrorAddOn>
          ) : null
        }
      />
      <ConfirmSheetModal
        title="Print p-tags?"
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirm={handleConfirmWithClose}
        content={
          <div>
            <ArticlesPrintPtagsQuantityContent
              itemsWithPieces={itemsWithPieces}
              itemNosAndTypeWithOrderedDetails={
                itemNosAndTypeWithOrderedDetails
              }
              onPrintPtagsQuantityChange={onPrintPtagsQuantityChange}
            />
          </div>
        }
      />
    </>
  );
};
